module.exports = __webpack_public_path__ + "img/system-5.47180f9.png";